import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ForgotPassword from './ForgotPassword';
import { LogoMarca } from '../../../components/logo';
import { UsuarioViewProps } from '../../usuario/usuario.controller';
import Alerts from '../../../components/alerts/Alerts';
import { Grid } from '@mui/material';



const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

export default function SignInCred(props: UsuarioViewProps) {
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');


  const handleSubmit = (data: any) => {
    if (emailError || passwordError) {
      return;
    }


    console.log({
      email: data.email,
      password: data.password
    });
    props.statusAppActions.login(data.email, data.password);
  };

  const validateInputs = () => {
    const email = document.getElementById('email') as HTMLInputElement;
    const password = document.getElementById('password') as HTMLInputElement;

    let isValid = true;

    if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
      setEmailError(true);
      setEmailErrorMessage('Digite um email válido.');
      isValid = true;
    } else {
      setEmailError(false);
      setEmailErrorMessage('');
    }

    if (!password.value) {
      setPasswordError(true);
      setPasswordErrorMessage('Informe a senha');
      isValid = true;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }
    if (isValid) {
      handleSubmit({ email: email.value, password: password.value })
    }
    return isValid;
  };

  return (
    <Box sx={{display:"flex", flex:1, flexDirection:"row", justifyContent:"center", alignItems:"center"}}>
    <Grid  container  justifyContent={"flex-start"}>
      <Grid flex={1} size={{ lg: 7, md: 7, sm: 12, xs: 12 }} sx={{display:"flex", justifyContent:"flex-start",alignItems:"center"}}>
        <LogoMarca height={100} width={250} />
      </Grid>
      <Grid flex={1} size={{ lg: 5, md: 5, sm: 12, xs: 12 }}>
        <Card variant="outlined">
          <Box
            sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}
          >
            <Typography variant='h5'>Login na Conta</Typography>
            <FormControl>
              <FormLabel htmlFor="email">Credencial de Acesso</FormLabel>
              <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                placeholder="Seu email da conta"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? 'error' : 'primary'}
              />
            </FormControl>
            <FormControl>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormLabel htmlFor="password">Senha</FormLabel>
              </Box>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                placeholder="••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                required
                fullWidth
                variant="outlined"
                color={passwordError ? 'error' : 'primary'}
              />
            </FormControl>
            <Button fullWidth variant="contained" onClick={validateInputs}>
              Confirmar
            </Button>
          </Box>
          <Typography alignSelf={"end"} variant='caption'>Versão {props.statusAppState.versao}</Typography>
          <Alerts show={props.statusAppState.showAlert} handleClose={() => props.statusAppActions.setShowAlert(false)} menssage={props.statusAppState.msg} tipoAlerta='error' />
        </Card>
      </Grid>
    </Grid>
    </Box>

  );
}
